import { post } from './index';

import { IUserRegistrationPayload, IUserRegistrationResult, IUserLoginPayload, IUserLoginResult } from 'models/payloads/auth';

export const registerUser = (payload: IUserRegistrationPayload) => post<IUserRegistrationPayload, IUserRegistrationResult>('/user', payload, true);
export const loginUser = (payload: IUserLoginPayload) => post<IUserLoginPayload, IUserLoginResult>('/user/login', payload, true);
